import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { CustomTrackerEvent } from './custom_tracker_events';

@Injectable({ providedIn: 'root' })
export class CustomTrackerEventProvider extends DomainEventProvider<CustomTrackerEvent> {}
